exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "* {\n  margin: 0;\n  padding: 0;\n  border: none;\n  box-sizing: border-box;\n  -webkit-user-select: none;\n}\nhtml,\nbody {\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n.root {\n  height: 100%;\n  width: 100%;\n  position: relative;\n}\n.root .scope {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n}\n.icon {\n  background-image: url(" + require("../images/doc.png") + ");\n  background-position: center center;\n  background-repeat: no-repeat;\n}\n.icon.firefox {\n  background-image: url(" + require("../images/firefox.png") + ");\n}\n.icon.chrome {\n  background-image: url(" + require("../images/chrome.png") + ");\n}\n.icon.safari {\n  background-image: url(" + require("../images/safari.png") + ");\n}\ninput[type=text] {\n  border: 1px solid;\n  cursor: text;\n  -webkit-user-select: initial;\n}\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/views/root.vue
 ** module id = 24
 ** module chunks = 0
 **/